import { SHOW_SHIPPING_ADDRESS_WARNING_MODAL } from './constants'

export default function shippingAddressHTQuoteReducer(
    state = {},
    action: { type: string; showModal: boolean },
) {
    const { type, showModal } = action

    switch (type) {
        case SHOW_SHIPPING_ADDRESS_WARNING_MODAL:
            return { ...state, showModal }
        default:
            return state
    }
}
